<template>
  <div class="article-author-card">
    <div
      v-if="content.LogoImageUrl && !logoImageError"
      class="article-author-card__author-img"
    >
      <img
        :src="content.LogoImageUrl"
        :alt="content.Name"
        @error="logoImageErrorHandler"
      >
    </div>
    <div class="article-author-card__content">
      <div class="article-author-card__content__author-name">
        <p>{{ content.Name }}</p>
        <!-- <i class="icon icon-chevron-right arrow"></i> -->
      </div>
      <span class="article-author-card__content__author-intro">{{ isMobile ? content.aboutSourseForMobile : content.aboutSourseForWeb }}</span>
    </div>
    <div
      v-if="content.RelatedLink"
      class="article-author-card__btn"
    >
      <v-btn
        outlined
        color="primary"
        @click="openRelatedLink"
      >
        相關連結
        <i class="icon icon-arrow-right-bold" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    content: {
      type: Object,
      default: () => {
        return {
          Name: '',
          About: '',
          LogoImageUrl: '',
          RelatedLink: ''
        }
      }
    }
  },
  data () {
    return {
      logoImageError: false
    }
  },
  computed: {
    ...mapGetters([
      'isMobile'
    ])
  },
  methods: {
    logoImageErrorHandler () {
      this.logoImageError = true
    },
    openRelatedLink () {
      this.$gaLogEvent('文章來源', `文章來源連結_${this.content.Name}`)
      window.open(this.content.RelatedLink, '_blank')
    }
  }
}
</script>

<style lang="scss">
.article-author-card {
  background: $color-background-primary;
  width: 291px;
  padding: 24px 16px 16px 24px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  &__author-img {
    width: 80px;
    height: 80px;
    margin-right: auto;
    margin-bottom: 16px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  &__content {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;
    &__author-name {
      display: flex;
      align-items: center;
      font-size: pxTorem(17px);
      font-weight: bold;
      margin-bottom: 6px;
      p {
        margin: 0;
        margin-right: 12px;
      }
      i {
        color: $color-primary;
        font-weight: bold;
      }
    }
    &__author-intro {
      font-size: pxTorem(15px);
    }
  }
  &__btn {
    margin-top: auto;
    margin-left: auto;
    background: #ffffff;
    i {
      font-weight: bold;
      &:before {
        color: $color-primary;
      }
    }
  }
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .article-author-card {
    flex-direction: row;
    flex-wrap: wrap;
    &__author-img {
      margin-right: 16px;
    }
    &__content {
      width: calc(100% - 96px);
    }
  }
}
</style>
